{{#if show_buttons}}
<button id="{{cid}}-audioButton" aria-label="{{t 'audioAccessibility.aria-stopped'}}" class="{{audio_status}} {{button_class}}" data-state="{{audio_status}}">{{display_status}}</button>
{{/if}}